import { useState, useRef, useEffect } from "react";
import { ChevronDown, Building2, Check, Globe } from "lucide-react";
import { useTransportadora } from "@/contexts/TransportadoraContext";

export const TransportadoraSelector = () => {
  const { selectedCnpj, setSelectedCnpj, transportadoras, selectedTransp } =
    useTransportadora();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const onPick = (cnpj) => {
    setSelectedCnpj(cnpj);
    setOpen(false);
    // Força reload da página para reagregar todos os dados com o novo filtro
    window.location.reload();
  };

  const label = selectedTransp ? selectedTransp.nome : "Todas as transportadoras";

  return (
    <div ref={ref} className="relative" data-testid="transp-selector">
      <button
        data-testid="transp-selector-trigger"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center gap-2 px-3 py-2 bg-[#FAFAFA] border border-[#E4E4E7] hover:border-[#09090B] rounded-md transition-colors text-left"
      >
        {selectedCnpj ? (
          <Building2 size={14} className="text-[#09090B] shrink-0" />
        ) : (
          <Globe size={14} className="text-[#52525B] shrink-0" />
        )}
        <div className="flex-1 min-w-0">
          <div className="text-[9px] uppercase tracking-[0.15em] text-[#52525B] font-bold">
            Transportadora
          </div>
          <div className="text-xs font-semibold text-[#09090B] truncate">
            {label}
          </div>
        </div>
        <ChevronDown
          size={14}
          className={`text-[#52525B] shrink-0 transition-transform ${
            open ? "rotate-180" : ""
          }`}
        />
      </button>

      {open && (
        <div
          data-testid="transp-selector-menu"
          className="absolute left-0 right-0 mt-1 bg-white border border-[#09090B] rounded-md shadow-lg z-50 max-h-80 overflow-y-auto"
        >
          <button
            data-testid="transp-option-all"
            onClick={() => onPick("")}
            className={`w-full flex items-start gap-2 px-3 py-2.5 text-left text-sm hover:bg-[#FAFAFA] border-b border-[#E4E4E7] ${
              !selectedCnpj ? "bg-[#FAFAFA]" : ""
            }`}
          >
            <Globe size={14} className="text-[#52525B] mt-0.5" />
            <div className="flex-1 min-w-0">
              <div className="font-semibold text-[#09090B]">
                Todas as transportadoras
              </div>
              <div className="text-[11px] text-[#52525B]">
                Visão consolidada (sem filtro)
              </div>
            </div>
            {!selectedCnpj && <Check size={14} className="text-[#09090B]" />}
          </button>
          {transportadoras.map((t) => (
            <button
              key={t.cnpj}
              data-testid={`transp-option-${t.cnpj}`}
              onClick={() => onPick(t.cnpj)}
              className={`w-full flex items-start gap-2 px-3 py-2.5 text-left text-sm hover:bg-[#FAFAFA] border-b border-[#E4E4E7] last:border-b-0 ${
                selectedCnpj === t.cnpj ? "bg-[#FAFAFA]" : ""
              }`}
            >
              <Building2 size={14} className="text-[#09090B] mt-0.5 shrink-0" />
              <div className="flex-1 min-w-0">
                <div className="font-semibold text-[#09090B] truncate">
                  {t.nome || t.cnpj}
                </div>
                <div className="text-[11px] text-[#52525B] font-mono-data">
                  {t.total_arquivos} arq • {t.total_movimentacoes.toLocaleString("pt-BR")} eventos
                </div>
              </div>
              {selectedCnpj === t.cnpj && (
                <Check size={14} className="text-[#09090B] shrink-0" />
              )}
            </button>
          ))}
          {transportadoras.length === 0 && (
            <div className="px-3 py-4 text-xs text-[#52525B] text-center">
              Nenhuma transportadora detectada ainda.
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default TransportadoraSelector;
